import Api, { ErrorMode, FetchMethodType } from './Api';

export type AiCoachTurnOptionKind = 'accept' | 'skip' | 'edu' | 'model';
export enum AiCoachTurnOptionClientAction {
  StartGoal = 'startGoal',
  ConsolidateDebt = 'consolidateDebt',
  Intercom = 'intercom',
}

export interface AiCoachTurnOption {
  id: string;
  label: string;
  kind: AiCoachTurnOptionKind;
  clientAction?: AiCoachTurnOptionClientAction;
}

export type AiCoachTurnPhase = 'deterministic' | 'model';

export interface AiCoachTurn {
  messages: string[];
  options: AiCoachTurnOption[];
  terminal: boolean;
  phase: AiCoachTurnPhase;
}

/**
 * Opaque session token. The client stores it and sends it back untouched on the
 * next turn. Never inspect or mutate its internal fields.
 */
export interface AiCoachSessionState {
  phase: 'disclaimer' | 'active';
  frame: number;
  seen: string[];
  history: { role: 'assistant' | 'user'; content: string }[];
}

export interface AiCoachTurnResult {
  turn: AiCoachTurn;
  state: AiCoachSessionState;
  clientAction?: AiCoachTurnOptionClientAction;
}

export interface PostCoachConversationParams {
  appId: string;
  state?: AiCoachSessionState;
  optionId?: string;
}

export interface AICoachConversationApi {
  postCoachConversation(params: PostCoachConversationParams): Promise<AiCoachTurnResult>;
}

export default class AICoachConversationRestApi extends Api implements AICoachConversationApi {
  public async postCoachConversation({
    appId,
    state,
    optionId,
  }: PostCoachConversationParams): Promise<AiCoachTurnResult> {
    const body: { state?: AiCoachSessionState; optionId?: string } = {};
    if (state) body.state = state;
    if (optionId) body.optionId = optionId;

    return this.fetch<AiCoachTurnResult>(`/aiCoach/conversation/${appId}`, {
      method: FetchMethodType.POST,
      body,
      errorMode: ErrorMode.HideError,
    });
  }
}
